import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';

export type RevertSuplantUseCase = UseCase<void, void>;

export function revertSuplantBuilder(authRepository: AuthRepository): RevertSuplantUseCase {
	return async function revertSuplant(): Promise<void> {
		return authRepository.revertSuplant();
	};
}
